import headerTop from "../components/header-top.vue"
import qrBox from "../components/qr.vue"
import bottom from "../components/bottom.vue"
import waterFall from "../components/vue-waterfall-easy.vue"
import goTop from "../components/goTop.vue"

const components = {
  install: function (Vue) {
    Vue.component('headerTop', headerTop);
    Vue.component('qrBox', qrBox);
    Vue.component('bottom', bottom);
    Vue.component('waterFall', waterFall);
    Vue.component('goTop', goTop);
  }
}
export default components;


// WEBPACK FOOTER //
// ./src/components/index.js